import { useEffect, useState } from "react";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import FormStage from "./FormStage";
import UploadStage from "./UploadStage";
import Api from "../../../services/ApiService";
import { useNavigate } from "react-router-dom";

const RegisterComponent = ({qrData, setView, missingUploadToken}) => {

    const API = new Api();
    const [stage, setStage] = useState("form");
    const [apiError, setApiError] = useState("");
    const [tryAgainBtnHidden, setTryAgainBtnHidden] = useState(false);
    const params = new URLSearchParams(window.location.search);
    const form_uid = params.get("form_uid");
    const navigate = useNavigate();
    const [data, setData] = useState({
        company_type: "",
        x_is_house_management: false,
        case: null,
        companyKw: false,
        contactPerson: "",
        name: "",
        lastName: "",
        email: "",
        phone_country: "+43",
        vorwahl: "",
        phone: "",
        comment: "",
        situation: "",
        uploads: [],
        country_id: "12",
        state_id: "",
    });

    useEffect(() => {
        if (qrData !== undefined) {
            setData(prev => ({...prev, 
                qr_code: qrData.top.x_qrcode,
            }));
        }
    }, [qrData])

    useEffect(() => {
        if (missingUploadToken) {
            API.register_missing_document_get_user(missingUploadToken)
                .then(res => {
                    let resData = res.data;
                    var vorwahl = resData.mobile.split(" ")[1];
                    var phone = resData.mobile.split(" ")[2];
                    setData({
                        company_type: resData.company_type? resData.company_type:'',
                        x_is_house_management: false,
                        case: resData.change_or_new,
                        companyKw: false,
                        contactPerson: "",
                        name: resData.name,
                        lastName: resData.last_name,
                        email: resData.email,
                        phone_country: "+43",
                        vorwahl: vorwahl,
                        phone: phone,
                        comment: "",
                        situation: resData.situation,
                        uploads: [],
                        upload_later: missingUploadToken,
                        country_id: resData.country,
                        state_id: resData.state,
                        x_salespartner_campaign_code: resData.x_salespartner_campaign_code,
                        x_salespartner_campaign_document: resData.x_salespartner_campaign_document,
                    });
                })
                .catch(err => {
                    setApiError(<>
                        Erinnerungslink ist ungültig oder abgelaufen. Bitte wechseln Sie auf{' '}
                        <a className="link-energo text-warning" href="https://mein.energiepool.at" >
                        https://mein.energiepool.at
                        </a>{' '}
                        und reichen Sie Ihre Jahresabrechnung erneut ein, damit wir Ihnen ein Angebot zukommen lassen können.
                    </>);
                    setStage("error");
                    setTryAgainBtnHidden(true);
                })
        }
    }, [missingUploadToken])

    return (
        <div className="text-light">
            <h3 className="text-light"><span className="text-dark title-energo">ENERGO</span> - Willkommen!</h3>
            {
                stage === "error" ?
                    <div className="mt-5">
                        <h5 className="text-danger">Fehler aufgetreten</h5>
                        <p className="text-dark" style={{fontSize: 14, fontWeight: 800}}>{apiError}</p>
                        <div className="text-center">
                            {form_uid !== null?
                                <Button variant="warning" onClick={() => {setStage("form"); navigate("/")}}>zur Startseite</Button>:
                                <Button hidden={tryAgainBtnHidden} variant="warning" onClick={() => setStage("form")}>Nochmal versuchen</Button>
                            }
                        </div>
                    </div> :

                stage === "loading" ? 
                    <div className="mt-5 text-center">
                        <h5>Ihre Daten werden übermittelt</h5>
                        <Spinner animation="border" className="text-light"/>
                    </div> :

                stage === "reg_done"?
                    <div className="mt-5">
                        <h5>ENERGO ENERGIEDIENSTLEISTUNGEN GmbH</h5>
                        <br />
                        <p style={{fontSize: 14, fontWeight: 800, marginBottom: 20}} className="text-light">
                            Vielen Dank für die Bekanntgabe Ihrer Daten! <br />
                            Wir haben Ihnen ein E-Mail gesendet, um Ihre E-Mail-Adresse
                            zu verifizieren.
                        </p>
                        <Row>
                            <Col className="text-center">
                                <Button variant="warning" onClick={() => setView('login')}>Verstanden</Button>
                            </Col>
                        </Row>
                    </div> :

                stage === "ticket_done" ?
                    <div className="mt-5">
                        <h5>Kontaktaufnahme</h5>
                        <figure>
                            <blockquote className="blockquote">
                                {data.companyKw ?
                                    <p style={{fontSize: 14, fontWeight: 800, marginBottom: 20}} className="text-dark">
                                        Wir haben Ihre Daten erhalten und werden uns in Kürze bei Ihnen melden.
                                    </p>
                                    :
                                    <p className="text-dark">
                                        Wir haben Ihre Daten erfasst und werden uns in Kürze mit einem Vergleichsangebot bei Ihnen melden.
                                    </p>
                                }
                            </blockquote>
                            <figcaption className="blockquote-footer text-end text-light">
                                <b>Ihr ENERGO Team</b>
                            </figcaption>
                        </figure>
                    </div> :

                stage === "upload_missing" ?
                    <div className="mt-5">
                        <h5>E-Mail gesendet!</h5>
                        <p className="text-dark" style={{fontSize: 14, fontWeight: 800}}>
                            Vielen Dank für Ihr Interesse!
                            Wir haben Ihnen zur Erinnerung ein E-Mail gesendet.
                        </p>
                    </div> :

                stage === "form" ? 
                    <FormStage setStage={setStage} data={data} setData={setData} setApiError={setApiError}/> :

                stage === "upload" ?
                    <UploadStage data={data} setData={setData} setStage={setStage} setApiError={setApiError} /> :
                null
            }
        </div>
    )
}
export default RegisterComponent;